import React from 'react';
import { Point } from '@printu/geom';
import { getViewportVirtualToCanvasScale } from '@printu/viewport';
import { WatermarkInSvg } from 'app/assets/brands/Logo';
import { useConnect } from 'app/views/hooks/useConnect';
import { toDomPrecision, toPx } from 'app/utils/DOM';
export const Watermark = () => {
    const scale = useConnect(state => getViewportVirtualToCanvasScale(state.viewport));
    const margin = Point.from(10, 10).scale(scale).negate();
    return (React.createElement("div", { className: "project-watermark", style: { position: 'absolute', right: '0', bottom: '0' } },
        React.createElement("div", { className: "project-watermark__image", style: {
                transformOrigin: 'bottom right',
                transform: `translate(${toPx(margin.x)}, ${toPx(margin.y)}) scale(${toDomPrecision(scale)})`,
            } },
            React.createElement(WatermarkInSvg, null))));
};
